import type { RenderLink } from '@opendoor/atoms/utils';
import { getCustomerNavigationHref } from 'components/account/impersonation';
import NextLink from 'next/link';

export const renderAtomsLink: RenderLink = ({ to, href, ref, children, ...rest }) => (
  <NextLink href={getCustomerNavigationHref(href ?? to ?? '')} ref={ref} {...rest}>
    {children}
  </NextLink>
);
